let actions = {
    /**
     * @param commit
     * @returns {Promise<any>}
     */
    GET_TEAMS({commit}) {
        return axios.get(route('schedule.planning.team.all'))
            .then(response => {
                commit('person', response.data.person);
                commit('setTeams', response.data.teams);
                commit('setCachedTeams', Object.freeze(response.data.teams));
                commit('setProjects', response.data.projects);
                commit('setTasks', response.data.tasks);
                commit('setAbsenceTypes', response.data.absenceTypes);
                commit('setSlotTitleSettings', response.data.slotTitleSettings);
                commit('canBeManaged', response.data.canBeManaged);
            })
            .catch();
    },
    /**
     * @param commit
     * @param payload
     * @returns {Promise<any>}
     */
    SET_TEAMS({commit}, payload) {
        commit('setTeams', payload);
    },
    /**
     * @param commit
     * @param payload
     * @returns {Promise<any>}
     */
    SET_CACHED_TEAMS({commit}, payload) {
        commit('setCachedTeams', payload);
    },
    /**
     * @param commit
     * @returns {Promise<any>}
     */
    GET_STATUSES({commit}) {
        return axios.get(route('schedule.planning.task.statuses'))
            .then(response => {
                commit('setStatuses', response.data.statuses);
            })
            .catch();
    },
    /**
     * @param commit
     * @param payload
     * @returns {Promise<any>}
     */
    GET_GROUPS({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios.get(route('schedule.planning.team.groups', payload))
                .then(response => {
                    commit('getGroups', response.data.groups);

                    resolve(response.data);
                })
                .catch(error => {
                    console.error({error});
                });
        });
    },
    SET_GHOST_GROUP({commit}, payload) {
        commit('setGhostGroup', payload);
    },
    /**
     * @param commit
     * @param payload
     * @returns {Promise<any>}
     */
    SET_FULL_DAY_ABSENCES({commit}, payload) {
        commit('setFullDayAbsences', payload);
    },
    /**
     * @param commit
     * @param payload
     * @returns {Promise<any>}
     */
    SET_PART_DAY_ABSENCES({commit}, payload) {
        commit('setPartDayAbsences', payload);
    },
    /**
     * @param commit
     * @param payload
     * @returns {Promise<any>}
     */
    SET_WEEK_SCHEDULES({commit}, payload) {
        commit('setWeekSchedules', payload);
    },
    /**
     * @param commit
     */
    UPDATED({commit}) {
        commit('updated', (new Date()).getTime());
    },
    /**
     * @param commit
     * @param payload
     */
    ON_GROUP_DRAG_START({commit}, payload) {
        commit('draggingGroup', payload);
    },
    /**
     * @param commit
     * @param payload
     */
    SET_PLANNING({commit}, payload) {
        commit('planning', payload);
    },
    /**
     * @param commit
     */
    CLEANUP({commit}) {
        commit('setTeams', []);
        commit('setProjects', []);
        commit('setTasks', []);
        commit('setAbsenceTypes', []);
        commit('setSlotTitleSettings', {});
        commit('canBeManaged', []);
        commit('updated', null);
        commit('setWeekSchedules', {});
        commit('setPartDayAbsences', {});
        commit('setFullDayAbsences', {});
        commit('getGroups', []);
        commit('setStatuses', []);
        commit('planning', 0);
    }
};

export default actions;